export default function isCepValid(cep: string): boolean {
  // Expressão regular para verificar o formato do CEP (00000-000)
  const cepRegex = /^[0-9]{5}-[0-9]{3}$/;

  // Testa se a string fornecida corresponde ao formato do CEP
  return cepRegex.test(cep);
}
